const autoplayDelayAllowedValues = [3, 4, 5, 6, 7, 8, 9, 10];
export const getAutoplayDelayMs = (autoplayDelay) => {
    if (autoplayDelayAllowedValues.includes(autoplayDelay)) {
        return autoplayDelay * 1000;
    }
    return 5000;
};
//# sourceMappingURL=getAutoplayDelayMs.js.map